import React, { useEffect, useState } from "react";
import { GCLInfoModal } from "./modals/GCLInfoModal";
import { OrderIdModal } from "./modals/OrderIdModal";
import Step_BillingDetails from "../steps/Step_BillingDetails";
import Step_DeviceId from "../steps/Step_DeviceId";
import Step_GCL from "../steps/Step_GCL";
import Step_ShowOrder from "../steps/Step_ShowOrder";
import Step_VAT from "../steps/Step_VAT";
import Step_VerifyOrder from "../steps/Step_VerifyOrder";
import { useStepsStore } from "../stores/StepsStore";
import { IStepsTypes } from "../typings";
import { VATInfoModal } from "./modals/VATInfoModal";
import Step_AfterGCL from "../steps/Step_AfterGCL";
import { NCFFragment } from "./fragments/NCFFragment";
import { RegistrationHeader } from "./fragments/RegistrationHeader";
import { RegistrationFooter } from "./fragments/RegistrationFooter";
import { RegistrationActions } from "./fragments/RegistrationActions";
import StepCompleteAbstract from "../steps/StepCompleteAbstract";


const Flow: React.FC<{ addNcf: boolean; }> = ({ addNcf }) => {
    const { deviceId, orderId, newCustomerForm, currentStep, nextStep, previousStep, flow, error, emergencyDetailsErrors, userDetailsErrors, gclErrors, setSteps, clearError, execution } = useStepsStore();
    const [loading, setLoading] = useState(true);
    const [showGCL, setShowGCL] = useState(false);
    const [showVAT, setShowVAT] = useState(false);
    const [showOrderIdModal, setShowOrderIdModal] = useState(false);
    const [choosenSteps, setChoosenSteps] = useState<IStepsTypes[]>([]);

    const availableSteps: IStepsTypes[] = ['deviceId', 'verifyOrder', 'showOrder', 'ncf_userDetails', 'ncf_medicalDetails', 'ncf_emergency', 'billing_details', 'vat_details', 'gcl', 'after_gcl', 'final'];

    useEffect(() => {
        if (addNcf) {
            setChoosenSteps(availableSteps);
            setSteps(availableSteps);
        } else {
            setChoosenSteps(['deviceId', 'verifyOrder', 'showOrder', 'billing_details', 'vat_details', 'gcl', 'after_gcl', 'final']);
            setSteps(['deviceId', 'verifyOrder', 'showOrder', 'billing_details', 'vat_details', 'gcl', 'after_gcl', 'final']);
        }
    }, []);

    useEffect(() => {
        setLoading(false);
    }, [flow, currentStep, error, emergencyDetailsErrors, userDetailsErrors, gclErrors, execution]);

    const handleNext = () => {
        clearError();
        if (currentStep !== 'final') {
            setLoading(true);
            nextStep();
        } else {
            window.location.href = NCFFragment(deviceId ?? '', orderId ?? 0, newCustomerForm);
        }
    };

    const handlePrevious = () => {
        clearError();
        setLoading(false);
        if (currentStep !== 'deviceId') {
            previousStep();
        }
    };

    const openGCLModal = () => {
        setShowGCL(true);
    };

    const closeGCLModal = () => {
        setShowGCL(false);
    };

    const openOrderIdModal = () => {
        setShowOrderIdModal(true);
    };

    const closeOrderIdModal = () => {
        setShowOrderIdModal(false);
    };

    const openVATModal = () => {
        setShowVAT(true);
    };

    const closeVATModal = () => {
        setShowVAT(false);
    };

    return (
        <>
            {showOrderIdModal ? <OrderIdModal onClose={closeOrderIdModal} /> : ''}
            {showGCL ? <GCLInfoModal onClose={closeGCLModal} /> : ''}
            {showVAT ? <VATInfoModal onClose={closeVATModal} /> : ''}
            <div id="registration-flow">
                <div className="registration-flow">
                    <RegistrationHeader choosenSteps={choosenSteps} />
                    <div className="reg-content">
                        {currentStep === 'deviceId' ? <div className="fade-in"><Step_DeviceId onNext={handleNext}></Step_DeviceId></div> : ''}
                        {currentStep === 'verifyOrder' ? <div className="fade-in"><Step_VerifyOrder onNext={handleNext} openFindOrderIDModal={openOrderIdModal} ></Step_VerifyOrder></div> : ''}
                        {currentStep === 'showOrder' ? <div className="fade-in"><Step_ShowOrder></Step_ShowOrder></div> : ''}
                        {currentStep === 'billing_details' ? <div className="fade-in"><Step_BillingDetails onpenVATModal={openVATModal}></Step_BillingDetails></div> : ''}
                        {currentStep === 'vat_details' ? <div className="fade-in"><Step_VAT></Step_VAT></div> : ''}
                        {currentStep === 'gcl' ? <div className="fade-in"><Step_GCL></Step_GCL></div> : ''}
                        {currentStep === 'after_gcl' ? <div className="fade-in"><Step_AfterGCL></Step_AfterGCL></div> : ''}
                        {currentStep === 'final' ? <div className="fade-in"><StepCompleteAbstract title="Thank you" subtitle="Your direct debit has been successfully set up." title2="Last important step" subtitleLine2="We need you to complete our new customer form. This provides our team with essential information to be able to help in an emergency." /></div> : ''}
                        <RegistrationActions loading={ loading } handleNext={ handleNext } handlePrevious={ handlePrevious } />
                        {currentStep === 'gcl' ? <div className="click-gcl-info">
                            When you click Pay in GoCardless, you'll be taken to the secure GoCardless page to complete your payment.
                        </div> : ''}
                        <RegistrationFooter  openGCLModal={ openGCLModal } />
                    </div>
                </div>
            </div>
        </>);
};

export default Flow;